<template>
	<div>
		<div class="p-layout-breadcrumb">
			<el-row type="flex" align="middle">
				<el-col :span="3">
					<h3>专题列表</h3>
				</el-col>
				<el-col :span="2">
					<el-button type="info" @click="handleAdd">新建</el-button>
				</el-col>
			</el-row>
		</div>
		<el-table :data="fetchList" :default-sort = "{prop: 'title', prop: 'caption', prop: 'topicType'}">
			<el-table-column prop="title" sortable label="专题标题">
			</el-table-column>
			<el-table-column inline-template :context="_self" label="图片" width="180">
				<img :src="row.banner" class="user-pic" />
			</el-table-column>
			<el-table-column prop="caption" label="专题描述" sortable>
			</el-table-column>
			<el-table-column inline-template :context="_self" label="分类／标签" width="180" prop="topicType" sortable>
				<div>
					<span v-if="row.topicType === 0">
				            分类
				          </span>
					<span v-else-if="row.topicType === 1">
				            标签
				        </span>
				</div>
			</el-table-column>
			<el-table-column inline-template :context="_self" width="150" label="操作">
				<span>
				                  <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
				                  <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role === '1'">删除</el-button>
				        </span>
			</el-table-column>
		</el-table>
	
		<div class="page-footer">
			<el-button type="primary" @click="next" size="large">下一步</el-button>
		</div>
		<el-dialog title="编辑用户" v-model="editFormVisible">
			<el-form :model="editForm">
				<el-form-item label="用户名" label-width="100px">
					<el-input v-model="editForm.username" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="地址" label-width="100px">
					<el-select v-model="editForm.address" placeholder="请选择活动区域">
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editFormVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getVersions,
		getGlobalSettings,
		filterIndexVersions,
		getProductCategories,
		getProductTags,
		getProductDetails
	} from '../../api/version'
	
	export default {
		data() {
			return {
				Role: sessionStorage.power,
				fetchList: [],
				editFormVisible: false,
				editForm: {
					username: '',
					address: ''
				},
				imgUrl: '',
				uptoken: {
					token: sessionStorage.token
				}
			}
		},
	
		created() {
			let currentData = this.$store.state.currentIndex
			this.fetchList = currentData.value.topic
		},
	
		methods: {
			handleEdit(index, row) {
				console.log(row)
				this.$router.push('/editTopic/' + row.caption)
			},
			handleAdd() {
				this.$router.push('/addtopic')
			},
			next() {
				let currentData = this.$store.state.currentIndex
				if (currentData.value.topic.length) {
					this.$router.push('/shopList')
				} else {
					this.$message({
						message: '请先添加专题',
						type: 'warning'
					});
				}
			},
			handleDelete(index, row) {
				this.$confirm('此操作将永久删除该Banner, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.fetchList.splice(index, 1)
					let currentTopic = JSON.parse(JSON.stringify(this.fetchList))
					let currentData = this.$store.state.currentIndex

					currentData.value.topic = currentTopic
					this.$store.commit('SETCURRENTINDEX', currentData);
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					// this.refresh()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
	
		}
	}
</script>

<style>
	.user-pic {
		width: 50px;
		height: 50px;
		margin-top: 10px;
	}
	
	.avatar-uploader .el-upload {
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	
	.page-footer {
		margin-top: 60px;
		text-align: center;
	}
</style>




// WEBPACK FOOTER //
// IndexTopic.vue?fd221fc8